module.exports = __webpack_public_path__ + "img/volunteer-1.285808f6.jpg";